import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import axios from '@/api/config/axios';

window.Pusher = Pusher;

// Obtém a URL base da API do ambiente ou usa a padrão
const apiBaseURL = import.meta.env.VITE_APP_REST_API_V1 || import.meta.env.VITE_API_URL || '';
// Remove a barra final se existir e adiciona o endpoint de broadcasting
const authEndpoint = `${apiBaseURL.replace(/\/$/, '')}/broadcasting/auth`;

// Função customizada de autorização usando o axios configurado (com XSRF token e cookies)
const authorizer = (channel, options) => {
    return {
        authorize: (socketId, callback) => {
            console.log('🔐 Autenticando canal privado:', channel.name);
            axios.post(authEndpoint, {
                socket_id: socketId,
                channel_name: channel.name
            })
            .then(response => {
                console.log('✅ Autenticação do canal bem-sucedida');
                callback(null, response.data);
            })
            .catch(error => {
                console.error('❌ Erro na autenticação do canal privado:', error);
                console.error('Status:', error.response?.status);
                console.error('Detalhes:', error.response?.data || error.message);
                callback(error, null);
            });
        }
    };
};

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
    forceTLS: import.meta.env.VITE_PUSHER_SCHEME === 'https',
    wsHost: import.meta.env.VITE_PUSHER_HOST || `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
    wsPort: import.meta.env.VITE_PUSHER_PORT || 443,
    wssPort: import.meta.env.VITE_PUSHER_PORT || 443,
    enabledTransports: ['ws', 'wss'],
    authorizer: authorizer,
});
